import {
   HealthcareFacilityPart,
   HealthcareFacilityPartForCurrentOrganizationQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';

export const useHealthcareFacilityPartForCurrentOrganizationQuery = (): UseCqrsQueryResult<
   HealthcareFacilityPart[]
> => {
   return useCqrsSearch(() => {
      return new HealthcareFacilityPartForCurrentOrganizationQuery();
   });
};
